import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var BillboardService = /** @class */ (function () {
    function BillboardService(http) {
        this.http = http;
    }
    BillboardService.prototype.getBillboardData = function (eventId) {
        if (eventId === void 0) { eventId = 'jki30th'; }
        return this.http.get("/api/v1/events/" + eventId + "/billboard");
    };
    BillboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BillboardService_Factory() { return new BillboardService(i0.ɵɵinject(i1.HttpClient)); }, token: BillboardService, providedIn: "root" });
    return BillboardService;
}());
export { BillboardService };
